import { render, staticRenderFns } from "./AchievementData.vue?vue&type=template&id=04915b58&"
import script from "./AchievementData.vue?vue&type=script&lang=js&"
export * from "./AchievementData.vue?vue&type=script&lang=js&"
import style0 from "./AchievementData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports